var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAirplaneOfflineIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.607,
    height: 14.151,
    viewBox: "0 0 13.607 14.151",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "AirplaneOfflineIcon",
    "data-name": "Path 162",
    d: "M15.607,11.906V10.491L9.878,6.953V3.061a1.074,1.074,0,0,0-2.148,0V6.953L2,10.491v1.415l5.729-1.769v3.892L6.3,15.09v1.061L8.8,15.444l2.507.708V15.09L9.878,14.029V10.137Z",
    transform: "translate(-2 -2)",
    fill: "#aeb1b4"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAirplaneOfflineIcon);
export default __webpack_public_path__ + "static/media/AirplaneOfflineIcon.51b66bd272fb11c0feda9915afb17b37.svg";
export { ForwardRef as ReactComponent };